export interface Faq {
  id: string;
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    id: "faq-01",
    q: "瓜田速递是做什么的？",
    a: "瓜田速递是一个娱乐快讯推送站，把正在发酵的热点按时间线整理好，24 小时滚动更新。打开就能看到当前在讨论什么、有哪些配套截图、事情往哪个方向走，不用再满网追着跑。",
  },
  {
    id: "faq-02",
    q: "实时快报多久更新一次？",
    a: "时间线是 24 小时滚动更新的。热门事件通常会拆成多条快讯连续推进，从最早露出到后续发酵走向都会按时间顺序补上，方便你顺着脉络一次看完。",
  },
  {
    id: "faq-03",
    q: "快讯里的截图和讨论来自哪里？",
    a: "配套截图和讨论都来自公开渠道的网友讨论与公开内容，我们只做时间线整理与标注，不对未经证实的内容下结论。看到带「待核实」标记的条目时，请以官方通报为准。",
  },
  {
    id: "faq-04",
    q: "需要注册或登录才能看吗？",
    a: "不需要。全部快讯与时间线都可以直接浏览。如果你希望不错过重要节点，可以在页面底部留下邮箱订阅快讯推送。",
  },
  {
    id: "faq-05",
    q: "怎样避免被不实内容带偏？",
    a: "我们在每条快讯上标注来源与可信度状态，区分「已证实」「多方讨论」「待核实」三档。看时间线时留意标签，遇到只有单一来源、情绪强烈的说法先别急着转发。",
  },
];